.root {
  flex: none;
  vertical-align: middle;
}

/* The icon's 1.5 stroke is drawn on a 24px grid, so it renders at 1px only at 16px: at 13px it
   is a 0.8px hairline. A non-scaling 1px stroke keeps the line the same weight at every size the
   ⓘ is drawn at, so a small one is smaller, not thinner. `fill: none` because some legacy icon
   wrappers clear the svg's own fill attribute. */
.root path {
  vector-effect: non-scaling-stroke;
  stroke-width: 1px;
  fill: none;
}
